import * as React from "react";
import { Table, TableBody, TableHead, Typography } from "@mui/material";
import {
  CustomTableRow,
  TableCellColumn,
  TableCellHeading,
  TableRow
} from "./table.styled";
import Pagination from "../pagination/Pagination";
import Loader from "../loader/loader";

interface CustomTableWithPaginationProps {
  columns: Array<object>;
  data: Array<object>;
  apiStatus: string;
  payloadSize?: number;
  currentPage?: number;
  totalCount?: number;
  lastEvaluatedKey?: any;
  handleChangeRowsPerPage?: (val: any) => void;
  handleChangePage?: (e: any, val: any) => void;
  isShowPagination: boolean;
  noDataFoundMessage?: string;
  handleRowClick?: (row: any) => void;
  sx?: any;
}

const CustomTableWithPagination: React.FC<CustomTableWithPaginationProps> = ({
  columns = [],
  data = [],
  apiStatus = "",
  payloadSize = 10,
  currentPage = 1,
  totalCount = 0,
  lastEvaluatedKey = null,
  handleChangeRowsPerPage = (val: any) => {},
  handleChangePage = (e: any, val: any) => {},
  isShowPagination = true,
  noDataFoundMessage = "No Data Available",
  handleRowClick = (row: any) => {},
  sx = {}
}) => {
  return (
    <>
      {data?.length > 0 && apiStatus !== "fetching" ? (
        <div style={{ overflowY: "auto" }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns?.map((column: any) => (
                  <TableCellHeading
                    key={column?.id}
                    align={column?.align}
                    style={{ minWidth: column?.minWidth }}
                  >
                    {column?.headerFormat ? column.headerFormat() : column?.label}
                  </TableCellHeading>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row: any) => {
                return (
                  <CustomTableRow onClick={() => handleRowClick(row)} sx={sx}>
                    {columns?.map((column: any) => {
                      const value = row[column?.id];
                      return (
                        <TableCellColumn key={column?.id}>
                          {column?.format(value, row)}
                        </TableCellColumn>
                      );
                    })}
                  </CustomTableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      ) : apiStatus === "fetching" ? (
        <Loader />
      ) : (
        <Typography variant="h5" mb={2} align="center">
          {noDataFoundMessage}
        </Typography>
      )}

      {isShowPagination && apiStatus === "idle" && (
        <Pagination
          payloadSize={payloadSize}
          currentPage={currentPage}
          totalCount={totalCount}
          lastEvaluatedKey={lastEvaluatedKey}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleChangePage={handleChangePage}
        />
      )}
    </>
  );
};

export default CustomTableWithPagination;
